import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minWordsValidator(minWords: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // No input, so valid.
    }

    // Split the value by spaces and filter out empty strings.
    const words = control.value
      .trim()
      .split(/\s+/)
      .filter((word: string) => word.length > 0);

    // Check if word count is less than required.
    if (words.length < minWords) {
      return { minWords: { requiredWords: minWords, actualWords: words.length } };
    }

    return null; // Valid if word count is greater than or equal to minWords.
  };
}
